export default __webpack_public_path__ + "static/media/group70-mobile.7ee66217.png";